import { Box, Button, Divider, Grid, Popover } from '@mui/material';
import React, { useState, MouseEvent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import WSTextField from '../TextBox/WSTextBox';
import WSSelectField from '../Select/WSSelect';
import WSDateField from '../DateField/WSDateField';
import WSMultiCheckBox from '../CheckBox/WSMultiCheckBox';
import { IOptions } from '../Lib/Lib';
import WSRadioField from '../Radio/WSRadio';

interface IFilterProps {
    rows: IRows[];
    onFilterChange: (filters: any) => void;
    alignment?: 'left' | 'center' | 'right';
}

export interface IRows {
    type: string;
    label: string;
    fieldName: string;
    options?: IOptions[];
    range?: boolean;
    operator?: string;
    align?: 'horizontal' | 'vertical';
}

interface IFilter {
    field: string;
    operator: Operator | string;
    value: string | number;
}

export enum Operator {
    EqualTo = 'eq',
    NotEqualTo = 'neq',
    GreaterThan = 'gt',
    LessThan = 'lt',
    Like = 'like',
}

export const WSFilterComponent: React.FC<IFilterProps> = React.memo(({ rows, onFilterChange, alignment = 'left' }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const methods = useForm();
    const { register, handleSubmit, control, reset, formState: { } } = methods;

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        reset();
    };

    const handleReset = () => {
        reset();
        onFilterChange([]);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'filter-popover' : undefined;

    const removeEmptyFilters = (filters: any) => {
        return Object.keys(filters).reduce((acc, key) => {
            const value = filters[key];
            if (value !== null && value !== undefined && value !== '' && !(Array.isArray(value) && value.length === 0)) {
                acc[key] = value;
            }
            return acc;
        }, {} as any);
    };

    const onSubmit = (data: any) => {
        console.log('Filters data:', data);
        const cleanedFilters = removeEmptyFilters(data);
        const appliedFilters = rows.reduce((acc, column) => {
            if (cleanedFilters[column.fieldName]) {
                acc.push({
                    field: column.fieldName,
                    operator: column.operator || Operator.EqualTo,
                    value: cleanedFilters[column.fieldName],
                });
            }
            return acc;
        }, [] as IFilter[]);
        onFilterChange(appliedFilters);
        handleClose();
    };

    return (
        <>
            <Box display="flex" justifyContent={alignment} sx={{height:32}}>
                <Button aria-describedby={id} variant="contained" onClick={handleClick}>
                    Filter
                </Button>
            </Box>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                className="popover-main"
            >
                <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(onSubmit)} className="popover-content">
                    <Grid item style={{ margin:25 }}>
                        <Grid item container spacing={2}>
                            {rows.map(({ type, fieldName, label, options, align }) => (
                                <Grid item sm={6} key={fieldName}>
                                    {type === 'text' && (
                                        <WSTextField
                                            control={control}
                                            id={fieldName}
                                            {...register(fieldName)}
                                            name={fieldName}
                                            label={label}
                                          //  className="WSTextField"
                                        />
                                    )}
                                    {type === 'dropdown' && (
                                        <WSSelectField
                                            options={options}
                                            {...register(fieldName)}
                                            id={fieldName}
                                            control={control}
                                            label={label}
                                            name={fieldName}
                                           // className="WSTextField"
                                        />
                                    )}
                                    {type === 'date' && (
                                        <WSDateField
                                            id={fieldName}
                                            name={fieldName}
                                            label={label}
                                            dateFormat="D/MM/YYYY"
                                            control={control}
                                            defaultValue={null}
                                            rules={{ required: false }}
                                           // className="WSTextField"
                                        />
                                    )}
                                    {type === 'checkbox' && (
                                        <WSMultiCheckBox
                                            id={fieldName}
                                            label={label}
                                            name={fieldName}
                                            options={options || []}
                                            align={align}
                                            defaultValue={[]}
                                            rules={{ required: false }}
                                        />
                                    )}
                                     {type === 'radio' && (
                                       <WSRadioField
                                       id={fieldName}
                                       label={label}
                                       name={fieldName}
                                       options={options || []}
                                       defaultValue={[]}
                                       rules={{ required: false }}
                                       control={control}
                                  
                                     />
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                        <Box>
                            <br />
                            <Divider />
                        </Box>
                        <br />
                        <Grid container justifyContent="flex-end" spacing={1} style={{paddingTop:10}}>
                            <Grid style={{ paddingRight: '16px' }}>
                                <Button sx={{height:32}} type="submit" variant="contained" color="primary">
                                    Apply
                                </Button>
                            </Grid>
                            <Grid style={{ paddingRight: '20px' }}>
                                <Button sx={{height:32}} type="button" onClick={handleReset} variant="contained" color="primary">
                                    Reset
                                </Button>
                            </Grid>
                        </Grid>
                        </Grid>
                    </form>
                </FormProvider>
            </Popover>
        </>
    );
});
